// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.renderer__vjhr {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: var( --size-paddingSmall, 8px );
  justify-content: stretch;
  align-items: center;
}

.renderer__vjhr > .options_IrXc3 {
  opacity : 0; 
  transition: opacity 0.2s; 
}

.renderer__vjhr:hover > .options_IrXc3 {
  opacity : 1;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/groupings/dataViewers/ValueRenderer.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb","sourcesContent":["\n.renderer {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: var( --size-paddingSmall, 8px );\n  justify-content: stretch;\n  align-items: center;\n}\n\n.renderer > .options {\n  opacity : 0; \n  transition: opacity 0.2s; \n}\n\n.renderer:hover > .options {\n  opacity : 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"renderer": `renderer__vjhr`,
	"options": `options_IrXc3`
};
export default ___CSS_LOADER_EXPORT___;
